const RADIO_OPTION_MAX_WIDTH = 201
const RADIO_GROUP_GAP = 12

export const FIELD_CONTROL_MAX_WIDTH = RADIO_OPTION_MAX_WIDTH * 2 + RADIO_GROUP_GAP

export const POLICY_HOLDER_ID = 'Policyholder'
